module.exports = __webpack_public_path__ + "static/media/alladinwallet.67bafd3f.jpg";